<template>
  <div class="entry-area">
    <h3 class="form-ttl py-5">
      {{
        $t('register-page.form-title', {
          split: '/'
        })
      }}
    </h3>
    <div class="">
      <table class="table-custom" border="1" cellspacing="0" cellpadding>
        <tbody>
          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('study_status')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.study-status', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('study_status')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.study_status.$invalid && $v.study_status.$dirty
                    }"
                  >
                    <select
                      name="study_status"
                      v-model="study_status"
                      ref="study_status"
                      :disabled="isFieldReadonly('study_status')"
                      @click="preventChangeIfReadonly($event, 'study_status')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_study_status"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.study_status.$invalid &&
                      $v.study_status.$dirty &&
                      !$v.study_status.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[0].input_example
                        : getInputExample[0].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('last_academic_history')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.last-academic-history', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('last_academic_history')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.last_academic_history.$invalid &&
                        $v.last_academic_history.$dirty
                    }"
                    rows="3"
                    v-model.trim="$v.last_academic_history.$model"
                    ref="last_academic_history"
                    :readonly="isFieldReadonly('last_academic_history')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.last_academic_history.$invalid &&
                      $v.last_academic_history.$dirty &&
                      !$v.last_academic_history.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[1].input_example
                        : getInputExample[1].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('university_id')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.university', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  class="col-require text-right"
                  v-if="isFieldRequired('university_id')"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>

            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.university_id.$invalid && $v.university_id.$dirty
                    }"
                  >
                    <select
                      name=""
                      v-model="university_id"
                      ref="university_id"
                      :disabled="isFieldReadonly('university_id')"
                      @click="preventChangeIfReadonly($event, 'university_id')"
                      @change="onchangeUniversity"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_university"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.university_id.$invalid &&
                      $v.university_id.$dirty &&
                      !$v.university_id.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
              <div
                class="div-right mt-2"
                v-if="university_input_text_flag === 1"
              >
                <div class="input-relative">
                  <input
                    type="text"
                    name="school_name"
                    placeholder=""
                    class="input-custom"
                    v-bind:class="{
                      'error-validate':
                        $v.school_name.$invalid && $v.school_name.$dirty
                    }"
                    v-model.trim="$v.school_name.$model"
                    ref="school_name"
                  />
                  <span class="form-error-tip" v-show="requiredSchoolName">{{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}</span>
                  <span
                    class="form-error-tip"
                    v-if="!$v.school_name.maxLength"
                    >{{
                      $t('validate.out-of-range', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
              <div
                class="input-example-style"
                v-if="getInputExample.length !== 0"
              >
                {{
                  this.$i18n.locale === LANG_CODE_JAPANESE
                    ? getInputExample[1].input_example
                    : getInputExample[1].input_example_vn
                }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('faculty_id')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.faculty_id', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('faculty_id')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.faculty_id.$invalid && $v.faculty_id.$dirty
                    }"
                  >
                    <select
                      name=""
                      v-model="faculty_id"
                      ref="faculty_id"
                      @change="onchangeFaculty"
                      :disabled="isFieldReadonly('faculty_id')"
                      @click="preventChangeIfReadonly($event, 'faculty_id')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_faculty"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.faculty_id.$invalid &&
                      $v.faculty_id.$dirty &&
                      !$v.faculty_id.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
              <div class="div-right mt-2" v-if="faculty_input_text_flag === 1">
                <div class="input-relative">
                  <input
                    type="text"
                    name="faculty"
                    placeholder=""
                    class="input-custom"
                    v-bind:class="{
                      'error-validate': $v.faculty.$invalid && $v.faculty.$dirty
                    }"
                    v-model.trim="$v.faculty.$model"
                    ref="faculty"
                  />
                  <span class="form-error-tip" v-show="requiredFacultyName">{{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}</span>
                  <span class="form-error-tip" v-if="!$v.faculty.maxLength">{{
                    $t('validate.out-of-range', {
                      split: '/'
                    })
                  }}</span>
                </div>
              </div>
              <div
                class="input-example-style"
                v-if="getInputExample.length !== 0"
              >
                {{
                  this.$i18n.locale === LANG_CODE_JAPANESE
                    ? getInputExample[2].input_example
                    : getInputExample[2].input_example_vn
                }}
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('graduation_month')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.graduation-month', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('graduation_month')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div class="date-picker-relative">
                    <v-dialog
                      ref="modal_graduation_month"
                      v-model="modal_graduation_month"
                      :return-value.sync="graduation_month"
                      persistent
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"> mdi-calendar</v-icon>
                      </template>
                      <v-date-picker
                        v-model="graduation_month"
                        type="month"
                        :locale="getLocaleDatePicker()"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modal_graduation_month = false"
                          >{{
                            $t('component.btn-cancle', {
                              split: '/'
                            })
                          }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.modal_graduation_month.save(graduation_month)
                          "
                          >{{ $t('component.btn-ok') }}
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>

                    <v-menu class="v-menu-custom date-picker-relative">
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-text-field
                          v-model="graduationMonthFormattedTextField"
                          :hint="getHintMonth"
                          persistent-hint
                          v-bind="attrs"
                          v-on="on"
                          @blur="handleGraduationMonthFromTextField"
                          class="input-date-picker"
                        ></v-text-field>
                      </template>
                    </v-menu>
                  </div>
                  <span
                    class="form-error-tip"
                    v-if="
                      !$v.graduationMonthFormattedTextField
                        .graduationMonthFormatted
                    "
                  >
                    {{
                      $t('validate.date-invalid', {
                        split: '/'
                      })
                    }}
                  </span>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[3].input_example
                        : getInputExample[3].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('work_status_text')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-status', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('work_status_text')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.work_status_text.$invalid &&
                        $v.work_status_text.$dirty
                    }"
                    rows="8"
                    v-model.trim="$v.work_status_text.$model"
                    ref="work_status_text"
                    :readonly="isFieldReadonly('work_status_text')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.work_status_text.$invalid &&
                      $v.work_status_text.$dirty &&
                      !$v.work_status_text.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[2].input_example
                        : getInputExample[2].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('work_status')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-status', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('work_status')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>

            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{ 'select-error': requiredWorkStatus }"
                  >
                    <select
                      name=""
                      v-model="work_status"
                      ref="work_status"
                      :disabled="isFieldReadonly('work_status')"
                      @click="preventChangeIfReadonly($event, 'work_status')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_work_status"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>
                  <span class="form-error-tip" v-if="requiredWorkStatus">{{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}</span>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[4].input_example
                        : getInputExample[4].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="checkWorkStatus">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.company-name', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('company_name')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <input
                    type="text"
                    name="company_name"
                    placeholder=""
                    class="input-custom"
                    v-bind:class="{
                      'error-validate':
                        $v.company_name.$invalid && $v.company_name.$dirty
                    }"
                    v-model.trim="$v.company_name.$model"
                    ref="company_name"
                    :readonly="
                      !checkWorkStatusToDisplay ||
                      isFieldReadonly('company_name')
                    "
                  />

                  <span class="form-error-tip" v-show="requiredCompanyName">{{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}</span>
                  <span
                    class="form-error-tip"
                    v-if="!$v.company_name.maxLength"
                    >{{
                      $t('validate.out-of-range', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
                <div
                  class="input-example-style"
                  v-if="getInputExample.length !== 0"
                >
                  {{
                    this.$i18n.locale === LANG_CODE_JAPANESE
                      ? getInputExample[5].input_example
                      : getInputExample[5].input_example_vn
                  }}
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="checkWorkStatus">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.industry-type', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('industry_type')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{ 'select-error': requiredIndustryType }"
                  >
                    <select
                      name=""
                      v-model="industry_type"
                      :disabled="
                        !checkWorkStatusToDisplay ||
                        isFieldReadonly('industry_type')
                      "
                      @click="preventChangeIfReadonly($event, 'industry_type')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_industry_type"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span class="form-error-tip" v-show="requiredIndustryType">{{
                    $t('validate.required', {
                      split: '/'
                    })
                  }}</span>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[6].input_example
                        : getInputExample[6].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="checkWorkStatus">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.position', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('occupation_type')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{ 'select-error': requiredOccupationType }"
                  >
                    <select
                      name="occupation_type"
                      v-model="occupation_type"
                      @disabled="isFieldReadonly('occupation_type')"
                      @click="
                        preventChangeIfReadonly($event, 'occupation_type')
                      "
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_occupation_type_default"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span
                    class="form-error-tip"
                    v-if="isFieldRequired('occupation_type')"
                    v-show="requiredOccupationType"
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[7].input_example
                        : getInputExample[7].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="checkWorkStatus">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-contract-type', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('work_contract_type')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{ 'select-error': requiredWorkContractType }"
                  >
                    <select
                      name="work_contract_type"
                      v-model="work_contract_type"
                      :disabled="
                        !checkWorkStatusToDisplay ||
                        isFieldReadonly('work_contract_type')
                      "
                      @click="
                        preventChangeIfReadonly($event, 'work_contract_type')
                      "
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_work_contract_type"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span
                    class="form-error-tip"
                    v-show="requiredWorkContractType"
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[8].input_example
                        : getInputExample[8].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr class="tr-response" v-if="checkWorkStatus">
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.resignation-month', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('resignation_month')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div class="date-picker-relative">
                    <v-dialog
                      ref="dialog"
                      v-model="modal"
                      :return-value.sync="resignation_month"
                      persistent
                      max-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on"> mdi-calendar</v-icon>
                      </template>

                      <v-date-picker
                        v-model="resignation_month"
                        :locale="getLocaleDatePicker()"
                        scrollable
                      >
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"
                          >{{
                            $t('component.btn-cancle', {
                              split: '/'
                            })
                          }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.dialog.save(resignation_month)"
                          >OK
                        </v-btn>
                      </v-date-picker>
                    </v-dialog>

                    <v-menu class="v-menu-custom date-picker-relative">
                      <template
                        v-slot:activator="{ on, attrs }"
                      >
                        <v-text-field
                          v-model="resignationMonthFormattedTextField"
                          :hint="getHint"
                          persistent-hint
                          v-bind="attrs"
                          v-on="on"
                          @blur="handleResignationMonthFromTextField"
                          class="input-date-picker"
                        ></v-text-field>
                      </template>
                    </v-menu>
                  </div>
                  <span
                    class="form-error-tip"
                    v-if="
                      resignationMonthFormattedTextField !== '' &&
                      !$v.resignationMonthFormattedTextField
                        .resignationMonthFormatted
                    "
                  >
                    {{
                      $t('validate.date-invalid', {
                        split: '/'
                      })
                    }}
                  </span>
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[9].input_example
                        : getInputExample[9].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('jlpt_level')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.japanese-level', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('jlpt_level')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.jlpt_level.$invalid && $v.jlpt_level.$dirty
                    }"
                  >
                    <select
                      name="jlpt_level"
                      v-model="jlpt_level"
                      ref="jlpt_level"
                      :disabled="isFieldReadonly('jlpt_level')"
                      @click="preventChangeIfReadonly($event, 'jlpt_level')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_japanese_level"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.jlpt_level.$invalid &&
                      $v.jlpt_level.$dirty &&
                      !$v.jlpt_level.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[10].input_example
                        : getInputExample[10].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('english_level')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.english-level', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('english_level')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.english_level.$invalid && $v.english_level.$dirty
                    }"
                  >
                    <select
                      name="english_level"
                      v-model="english_level"
                      ref="english_level"
                      :disabled="isFieldReadonly('english_level')"
                      @click="preventChangeIfReadonly($event, 'english_level')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in c_english_level"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.english_level.$invalid &&
                      $v.english_level.$dirty &&
                      !$v.english_level.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[11].input_example
                        : getInputExample[11].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('toeic_score')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{ $t('register-page.step-two.toeic') }}
                </div>
                <div
                  v-if="isFieldRequired('toeic_score')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <input
                    type="text"
                    name="toeic_score"
                    class="input-custom2"
                    v-bind:class="{
                      'error-validate':
                        $v.toeic_score.$invalid && $v.toeic_score.$dirty
                    }"
                    v-model.trim="$v.toeic_score.$model"
                    ref="toeic_score"
                    :readonly="isFieldReadonly('toeic_score')"
                  />

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.toeic_score.$invalid &&
                      $v.toeic_score.$dirty &&
                      (!$v.toeic_score.numeric || !$v.toeic_score.between)
                    "
                    >{{
                      $t('validate.toeic-score-format', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
                <div
                  class="input-example-style"
                  v-if="getInputExample.length !== 0"
                >
                  {{
                    this.$i18n.locale === LANG_CODE_JAPANESE
                      ? getInputExample[12].input_example
                      : getInputExample[12].input_example_vn
                  }}
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('skill_type')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.skills', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('skill_type')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div
                  class="widget-skill mb-2"
                  v-for="(item, index) in skillArray"
                  :key="item.key"
                >
                  <div class="box-skill">
                    <div class="form-select-skill">
                      <select
                        v-model="skillArray[index].skillType"
                        :disabled="isFieldReadonly('skill_type')"
                        @click="preventChangeIfReadonly($event, 'skill_type')"
                      >
                        <option value="">
                          --
                          {{
                            $t('register-page.step-two.choose', { split: '/' })
                          }}
                          --
                        </option>
                        <option
                          v-bind:key="skill_type.id"
                          v-for="skill_type in m_skill_type"
                          v-bind:value="skill_type.skill_type_code"
                        >
                          {{ skill_type.name_convert }}
                        </option>
                      </select>
                    </div>

                    <div class="form-select-skill">
                      <select
                        v-model="skillArray[index].skill"
                        :disabled="isFieldReadonly('skill_type')"
                        @click="preventChangeIfReadonly($event, 'skill_type')"
                      >
                        <option
                          v-bind:key="skill.id"
                          v-for="skill in skills[index]"
                          v-bind:value="skill.id"
                        >
                          {{ skill.name_convert }}
                        </option>
                      </select>
                    </div>

                    <span class="form-error-tip" v-if="countSkill > 10">{{
                      $t('validate.toeic-score-format', {
                        split: '/'
                      })
                    }}</span>
                  </div>

                  <div class="btn-add-group">
                    <button
                      class="btn-add-skill"
                      v-on:click="handleAddSkill"
                      v-if="
                        checkSizeObject(skillArray) - 1 === item.key &&
                        countSkill <= 9
                      "
                    >
                      <v-icon>mdi-plus</v-icon>
                    </button>

                    <button
                      class="btn-add-skill"
                      v-on:click="handleDeleteSkill"
                      v-if="
                        checkSizeObject(skillArray) - 1 === item.key &&
                        item.key !== 0
                      "
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </button>
                  </div>
                </div>
                <div
                  class="input-example-style"
                  v-if="getInputExample.length !== 0"
                >
                  {{
                    this.$i18n.locale === LANG_CODE_JAPANESE
                      ? getInputExample[13].input_example
                      : getInputExample[13].input_example_vn
                  }}
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('skill_name_text')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.skill-text', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('skill_name_text')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.skill_name_text.$invalid && $v.skill_name_text.$dirty
                    }"
                    rows="3"
                    v-model.trim="$v.skill_name_text.$model"
                    ref="skill_name_text"
                    :readonly="isFieldReadonly('skill_name_text')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.skill_name_text.$invalid &&
                      $v.skill_name_text.$dirty &&
                      !$v.skill_name_text.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <span
                    class="form-error-tip"
                    v-if="!$v.skill_name_text.maxLength"
                    >{{
                      $t('validate.out-of-range', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[3].input_example
                        : getInputExample[3].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expect_occupation_type')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.occupation-type', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('expect_occupation_type')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>

            <td class="td-right">
              <div
                class="div-right"
                ref="expect_occupation_type"
                v-bind:class="{
                  'select-box-error':
                    $v.expect_occupation_type.$invalid &&
                    $v.expect_occupation_type.$dirty
                }"
              >
                <div class="input-relative">
                  <div
                    class="widget-checkbox mb-2"
                    v-for="(category, key) in m_occupation_type"
                    :key="key"
                  >
                    <label for=""
                      >- {{ category[0].occupation_category }}:</label
                    >
                    <div class="tree-checkbox">
                      <div
                        class="checkbox-item"
                        v-for="(item, index) in category"
                        :key="index"
                      >
                        <input
                          type="checkbox"
                          v-model="expect_occupation_type"
                          :value="item.id"
                        />
                        {{ item.name_convert }}
                      </div>
                    </div>
                  </div>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.expect_occupation_type.$invalid &&
                      $v.expect_occupation_type.$dirty &&
                      !$v.expect_occupation_type.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expect_occupation_type_text')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.occupation-type', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('expect_occupation_type_text')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.expect_occupation_type_text.$invalid &&
                        $v.expect_occupation_type_text.$dirty
                    }"
                    rows="3"
                    v-model.trim="$v.expect_occupation_type_text.$model"
                    ref="expect_occupation_type_text"
                    :readonly="isFieldReadonly('expect_occupation_type_text')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.expect_occupation_type_text.$invalid &&
                      $v.expect_occupation_type_text.$dirty &&
                      !$v.expect_occupation_type_text.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[4].input_example
                        : getInputExample[4].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expected_requirements')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.expected-requirements', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('expected_requirements')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.expected_requirements.$invalid &&
                        $v.expected_requirements.$dirty
                    }"
                    rows="5"
                    v-model.trim="$v.expected_requirements.$model"
                    ref="expected_requirements"
                    :readonly="isFieldReadonly('expected_requirements')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.expected_requirements.$invalid &&
                      $v.expected_requirements.$dirty &&
                      !$v.expected_requirements.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[5].input_example
                        : getInputExample[5].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('expected_pay')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.expected-pay', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('expected_pay')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.expected_pay.$invalid && $v.expected_pay.$dirty
                    }"
                    rows="5"
                    v-model.trim="$v.expected_pay.$model"
                    ref="expected_pay"
                    :readonly="isFieldReadonly('expected_pay')"
                  ></textarea>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.expected_pay.$invalid &&
                      $v.expected_pay.$dirty &&
                      !$v.expected_pay.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[6].input_example
                        : getInputExample[6].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('any_additional_comments')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.any-additional-comments', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  class="col-require text-right"
                  v-if="
                    m_template.participant_basic_info_type ===
                      this.EVENT_DEFAULT ||
                    isFieldRequired('any_additional_comments')
                  "
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <textarea
                    class="text-area"
                    placeholder=""
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.any_additional_comments.$invalid &&
                        $v.any_additional_comments.$dirty
                    }"
                    rows="5"
                    v-model.trim="$v.any_additional_comments.$model"
                    ref="any_additional_comments"
                    :readonly="isFieldReadonly('any_additional_comments')"
                  ></textarea>
                </div>
                <div
                  class="input-example-style"
                  v-if="getInputExample.length !== 0"
                >
                  {{
                    this.$i18n.locale === LANG_CODE_JAPANESE
                      ? getInputExample[7].input_example
                      : getInputExample[7].input_example_vn
                  }}
                </div>
              </div>
            </td>
          </tr>
          <tr
            class="tr-response"
            v-if="isShowEntryInformationField('work_location')"
          >
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.work-location', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('work_location')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  <div
                    class="form-select"
                    v-bind:class="{
                      'select-error':
                        $v.work_location.$invalid && $v.work_location.$dirty
                    }"
                  >
                    <select
                      name="work_location"
                      v-model="work_location"
                      ref="work_location"
                      :disabled="isFieldReadonly('work_location')"
                      @click="preventChangeIfReadonly($event, 'work_location')"
                    >
                      <option value="">
                        --
                        {{
                          $t('register-page.step-two.choose', {
                            split: '/'
                          })
                        }}
                        --
                      </option>
                      <option
                        v-bind:key="item.id"
                        v-for="item in m_work_location_applicant"
                        v-bind:value="item.id"
                      >
                        {{ item.name_convert }}
                      </option>
                    </select>
                  </div>

                  <span
                    class="form-error-tip"
                    v-if="
                      $v.work_location.$invalid &&
                      $v.work_location.$dirty &&
                      !$v.work_location.required
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <div
                    class="input-example-style"
                    v-if="getInputExample.length !== 0"
                  >
                    {{
                      this.$i18n.locale === LANG_CODE_JAPANESE
                        ? getInputExample[14].input_example
                        : getInputExample[14].input_example_vn
                    }}
                  </div>
                </div>
              </div>
            </td>
          </tr>
          <tr class="tr-response">
            <!-- feature #248-->
            <td class="td-left">
              <div class="div-left">
                <div class="col-title">
                  {{
                    $t('register-page.step-two.self_promotion', {
                      split: '/'
                    })
                  }}
                </div>
                <div
                  v-if="isFieldRequired('self_promotion')"
                  class="col-require text-right"
                >
                  {{
                    $t('register-page.status.required', {
                      split: '/'
                    })
                  }}
                </div>
              </div>
            </td>
            <td class="td-right">
              <div class="div-right">
                <div class="input-relative">
                  {{
                    $t('register-page.step-two.self_promotion_caption', {
                      split: '/'
                    })
                  }}
                  <textarea
                    class="text-area"
                    v-bind:class="{
                      'textarea-input': true,
                      'error-validate':
                        $v.self_promotion.$invalid && $v.self_promotion.$dirty
                    }"
                    rows="5"
                    v-model.trim="$v.self_promotion.$model"
                    ref="self_promotion"
                    :readonly="isFieldReadonly('self_promotion')"
                  ></textarea>
                  <span
                    class="form-error-tip"
                    v-if="
                      $v.self_promotion.$invalid && $v.self_promotion.$dirty
                    "
                    >{{
                      $t('validate.required', {
                        split: '/'
                      })
                    }}</span
                  >
                  <span
                    class="form-error-tip"
                    v-if="!$v.self_promotion.maxLength"
                    >{{
                      $t('validate.out-of-range', {
                        split: '/'
                      })
                    }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
          <!-- end feature #248-->
        </tbody>
      </table>

      <div class="bottom-btn text-center">
        <button class="btn-next-outline mr-2" v-on:click="goBack">
          {{ $t('register-page.btn.btn-back', { split: '/' }) }}
        </button>
        <button class="btn-next ml-2" v-on:click="nextStepThree">
          {{ $t('register-page.btn.btn-next', { split: '/' }) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mdiCalendar } from '@mdi/js';
import {
  between,
  maxLength,
  numeric,
  required
} from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';

import {
  EVENT_DEFAULT,
  HINT_TEXT_MONTH_JAPANESE,
  HINT_TEXT_MONTH_VIETNAMESE,
  LANG_CODE_JAPANESE,
  WORK_STATUS_NO,
  WORK_STATUS_YES
} from '@/common/constants';

import { dateFormated, monthFormated } from '@/validators/date';

export default {
  name: 'StepTwo',
  props: ['urlRegisterCode'],
  data: (vm) => {
    return {
      EVENT_DEFAULT,
      study_status: '',
      university_id: '',
      school_name: '',
      university_input_text_flag: '',
      requiredSchoolName: false,
      faculty_id: '',
      faculty_input_text_flag: '',
      requiredFacultyName: false,
      faculty: '',
      graduation_month: new Date().toISOString().substr(0, 7),
      graduationMonthFormattedTextField: vm.formatMonth(
        new Date().toISOString().substr(0, 7)
      ),
      work_status: WORK_STATUS_NO,
      company_name: '',
      industry_type: '',
      occupation_type: '',
      job_type: '',
      work_contract_type: '',

      resignation_month: '',
      resignationMonthFormattedTextField: '',

      jlpt_level: '',
      english_level: '',
      toeic_score: '',
      skill_type: [],
      expect_occupation_type: [],
      work_location: '',
      self_promotion: '', // feature #248

      status: '',
      checked: true,
      tooltipStatus: true,
      calendarIcon: mdiCalendar,
      modal: false,
      modal_graduation_month: false,
      locale: 'vi',
      monthFormatted: vm.formatDate(new Date().toISOString().substr(0, 7)),

      skillArray: {
        skill0: {
          key: 0,
          skillType: '',
          skills: [],
          skill: ''
        },
        skill1: {
          key: 1,
          skillType: '',
          skills: [],
          skill: ''
        },
        skill2: {
          key: 2,
          skillType: '',
          skills: [],
          skill: ''
        }
      },

      skills: {},

      countSkill: 0,

      last_academic_history: '',
      work_status_text: '',
      skill_name_text: '',
      expect_occupation_type_text: '',
      expected_requirements: '',
      expected_pay: '',
      any_additional_comments: '',

      checkWorkStatusToDisplay: false,

      requiredWorkStatus: false,
      requiredCompanyName: false,
      requiredIndustryType: false,
      requiredWorkContractType: false,
      requiredOccupationType: false,

      checkRetireWorkStatus: false
    };
  },

  validations() {
    const schoolNameValidation =
      this.university_input_text_flag == 1
        ? {
            required,
            maxLength: maxLength(50)
          }
        : {
            maxLength: maxLength(50)
          };
    const facultyNameValidation =
      this.faculty_input_text_flag == 1
        ? {
            required,
            maxLength: maxLength(50)
          }
        : {
            maxLength: maxLength(50)
          };

    let baseValidations = {};

    if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
      baseValidations = {
        study_status: {
          required
        },
        university_id: {
          required
        },
        school_name: schoolNameValidation,
        faculty_id: {
          required
        },
        faculty: facultyNameValidation,
        graduation_month: {
          required
        },
        graduationMonthFormattedTextField: {
          graduationMonthFormatted: monthFormated(
            'graduationMonthFormattedTextField'
          )
        },
        resignationMonthFormattedTextField: {
          resignationMonthFormatted: dateFormated(
            'resignationMonthFormattedTextField'
          )
        },
        work_status: {
          required
        },
        company_name: {
          maxLength: maxLength(50)
        },
        industry_type: {},
        occupation_type: {},
        work_contract_type: {},
        resignation_month: {},
        jlpt_level: {
          required
        },
        english_level: {
          required
        },
        toeic_score: {
          numeric,
          between: between(0, 990)
        },

        expect_occupation_type: {
          required
        },
        work_location: {
          required
        },
        self_promotion: {
          maxLength: maxLength(500)
        } // feature #248
      };
    } else {
      baseValidations = {
        last_academic_history: {
          required
        },
        work_status_text: {
          required
        },
        skill_name_text: {
          required,
          maxLength: maxLength(255)
        },
        expect_occupation_type_text: {
          required
        },
        expected_requirements: {
          required
        },
        expected_pay: {
          required
        },
        any_additional_comments: {},
        work_location: {
          required
        }
      };
    }

    // Apply form modifications only if they exist
    Object.keys(baseValidations).forEach((fieldName) => {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      // Handle required property modifications
      if (modification && modification.hasOwnProperty('required')) {
        if (modification.required === false) {
          delete baseValidations[fieldName].required;
        } else if (
          modification.required === true &&
          !baseValidations[fieldName].required
        ) {
          baseValidations[fieldName].required = required;
        }
      }

      // Handle type property modifications - convert numeric fields to text
      if (modification &&
          modification.type === 'text' &&
          baseValidations[fieldName].hasOwnProperty('numeric')) {
        // Remove numeric and between validators for text type fields
        delete baseValidations[fieldName].numeric;
        delete baseValidations[fieldName].between;
      }
    });

    return baseValidations;
  },

  watch: {
    resignation_month: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (datetime !== '') {
          if (this.$i18n.locale === LANG_CODE_JAPANESE) {
            const [year, month, day] = datetime.split('-');
            string = year + '/' + month + '/' + day;
          } else {
            const [year, month, day] = datetime.split('-');
            string = day + '/' + month + '/' + year;
          }
          this.resignationMonthFormattedTextField = string;
        }
      }
    },

    graduation_month: function (val, oldVal) {
      if (val !== oldVal) {
        let string = '';
        const datetime = val;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month] = datetime.split('-');
          string = year + '/' + month;
        } else {
          const [year, month] = datetime.split('-');
          string = month + '/' + year;
        }
        this.graduationMonthFormattedTextField = string;
      }
    },

    '$i18n.locale': function (val, oldVal) {
      if (val !== oldVal) {
        let stringResignationMonth = '';
        const resignationMonth = this.resignation_month;
        if (resignationMonth !== '') {
          if (this.$i18n.locale === LANG_CODE_JAPANESE) {
            const [year, month, day] = resignationMonth.split('-');
            stringResignationMonth = year + '/' + month + '/' + day;
          } else {
            const [year, month, day] = resignationMonth.split('-');
            stringResignationMonth = day + '/' + month + '/' + year;
          }
        }
        this.resignationMonthFormattedTextField = stringResignationMonth;

        let stringGraduationMonth = '';
        const graduationMonth = this.graduation_month;
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month] = graduationMonth.split('-');
          stringGraduationMonth = year + '/' + month;
        } else {
          const [year, month] = graduationMonth.split('-');
          stringGraduationMonth = month + '/' + year;
        }
        this.graduationMonthFormattedTextField = stringGraduationMonth;
      }
    },

    skills: function (val) {
      return val;
    },

    skillArray: {
      handler(val) {
        if (val) {
          const skills = {};
          let count = 0;
          const skillType = [];
          Object.keys(this.skillArray).map((key, index) => {
            const nameSkill = 'skill' + index;
            let skill = {};
            if (this.skillArray[key].skillType !== '') {
              const skillFiltered = this.dataFiltered(
                this.skillArray[key].skillType
              );
              if (this.skillArray[key].skill !== '') {
                skillType.push(this.skillArray[key].skill);
              }
              skill = Object.assign({}, skillFiltered);
            } else {
              this.skillArray[key].skill = '';
              skill = Object.assign({}, { key, skill_type: '', skill: '' });
            }
            count++;
            skills[nameSkill] = skill;
          });

          this.countSkill = count;
          this.skill_type = skillType;
          return (this.skills = Object.assign({}, skills));
        }
      },
      deep: true
    },

    work_status: function (val) {
      if (val !== '') {
        this.requiredWorkStatus = false;
        if (val == WORK_STATUS_YES) {
          this.checkRetireWorkStatus = true;
          this.checkWorkStatusToDisplay = true;
        } else {
          this.checkRetireWorkStatus = false;
          this.checkWorkStatusToDisplay = false;
          this.industry_type = '';
          this.occupation_type = '';
          this.company_name = '';
          this.work_contract_type = '';
        }
      }
    },

    errorCompanyName: function (val) {
      if (this.work_status === WORK_STATUS_YES && val === '') {
        this.errorCompanyName = true;
      } else {
        this.errorCompanyName = false;
      }
    },

    industry_type: function (val) {
      if (val !== '') {
        this.requiredIndustryType = false;
      }
    },

    occupation_type: function (val) {
      if (val !== '') {
        this.requiredOccupationType = false;
      }
    },

    company_name: function (val) {
      if (val !== '') {
        this.requiredCompanyName = false;
      }
    },

    work_contract_type: function (val) {
      if (val !== '') {
        this.requiredWorkContractType = false;
      }
    },
    skill_type: function (val) {
      this.skill_type = val;
    },
    school_name: function (val) {
      this.requiredSchoolName =
        val == '' && this.university_input_text_flag == 1;
    },
    faculty: function (val) {
      this.requiredFacultyName = val == '' && this.faculty_input_text_flag == 1;
    }
  },

  methods: {
    LANG_CODE_JAPANESE() {
      return LANG_CODE_JAPANESE;
    },
    /**
     * Sự kiện blur input để lưu lại ngày tháng đã nhập(resignation_month)
     */
    handleResignationMonthFromTextField() {
      let string = '';
      const datetime = this.resignationMonthFormattedTextField;
      if (datetime !== '' && this.checkDateFormate(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month, day] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        } else {
          const [day, month, year] = datetime.split('/');
          string = year + '-' + month + '-' + day;
        }
        this.resignation_month = string;
      } else {
        this.resignation_month = '';
      }
    },

    /**
     * Sự kiện blur input để lưu lại ngày tháng đã nhập(graduation_month)
     */
    handleGraduationMonthFromTextField() {
      let string = '';
      const datetime = this.graduationMonthFormattedTextField;
      if (this.checkMonthFormate(datetime)) {
        if (this.$i18n.locale === LANG_CODE_JAPANESE) {
          const [year, month] = datetime.split('/');
          string = year + '-' + month;
        } else {
          const [month, year] = datetime.split('/');
          string = year + '-' + month;
        }
        this.graduation_month = string;
      }
    },

    /**
     * Check if field is required based on form modifications (for display purposes)
     * @param {string} fieldName - The name of the field to check
     * @return {boolean} - True if the field is required, false otherwise
     */
    isFieldRequired(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('required')) {
        return modification.required;
      }
      // Default required fields for display based on template type
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        const defaultRequired = [
          'study_status',
          'university_id',
          'faculty_id',
          'graduation_month',
          'work_status',
          'jlpt_level',
          'english_level',
          'expect_occupation_type',
          'work_location'
        ];
        if (this.work_status === WORK_STATUS_YES) {
          defaultRequired.push(
            'company_name',
            'industry_type',
            'occupation_type',
            'work_contract_type'
          );
        }
        return defaultRequired.includes(fieldName);
      }
      const defaultRequired = [
        'last_academic_history',
        'work_status_text',
        'skill_name_text',
        'expect_occupation_type_text',
        'expected_requirements',
        'expected_pay',
        'work_location'
      ];
      if (this.work_status === WORK_STATUS_YES) {
        defaultRequired.push(
          'company_name',
          'industry_type',
          'occupation_type',
          'work_contract_type'
        );
      }
      return defaultRequired.includes(fieldName);
    },

    /**
     * Check if field is readonly based on form modifications
     * @param {string} fieldName - The name of the field to check
     * @return {boolean} - True if the field is readonly, false otherwise
     */
    isFieldReadonly(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      return modification ? modification.readonly : false;
    },

    /**
     * Get default value for field based on form modifications
     * @param {string} fieldName - The name of the field to get default value for
     * @return {string} - Default value for the field, or an empty string if not set
     */
    getFieldDefaultValue(fieldName) {
      const modification = this.formModifications.find(
        (mod) => mod.name === fieldName
      );
      return modification && modification.default_value
        ? modification.default_value
        : '';
    },

    preventChangeIfReadonly(event, fieldName) {
      if (this.isFieldReadonly(fieldName)) {
        event.preventDefault();
      }
    },

    // Get validation rules for a field based on form modifications
    getFieldValidationRules(fieldName) {
      const modification = this.m_event.modify_fields.find(
        (mod) => mod.name === fieldName
      );
      if (modification && modification.hasOwnProperty('validation')) {
        return modification.validation;
      }
      // Default validation rules based on template type
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        return {
          required: true,
          maxLength: 50
        };
      } else {
        return {
          required: true,
          maxLength: 255
        };
      }
    },

    inputCheck(name) {
      if (this.$v[name].$invalid && this.$v[name].$dirty) {
        this.$refs[name].focus();

        this.$nextTick(function () {
          const top = this.$refs[name].getBoundingClientRect().top;

          this.$refs[name].scrollTop = top;
        });
      }
    },

    /**
     * Kiểm tra dữ liệu đầu vào
     */
    validateForm() {
      this.$v.$touch();

      // check thông tin input
      // this.inputCheck('expect_occupation_type');
      if (this.m_template.participant_entry_info_type === this.EVENT_DEFAULT) {
        this.inputCheck('expect_occupation_type');
        this.inputCheck('toeic_score');
        this.inputCheck('english_level');
        this.inputCheck('jlpt_level');
        this.inputCheck('resignation_month');
        this.inputCheck('company_name');
        this.inputCheck('graduation_month');
        this.inputCheck('faculty');
        this.inputCheck('faculty_id');
        this.inputCheck('university_id');
        this.inputCheck('school_name');
        this.inputCheck('study_status');
        this.inputCheck('self_promotion'); // feature #248
        this.validateWorkStatus();
        this.validateSchoolName();
        this.validateFacultyName();
      } else {
        this.inputCheck('last_academic_history');
        this.inputCheck('work_status_text');
        this.inputCheck('skill_name_text');
        this.inputCheck('expect_occupation_type_text');
        this.inputCheck('expected_requirements');
        this.inputCheck('expected_pay');
        this.inputCheck('any_additional_comments');
      }
      this.inputCheck('work_location');
    },

    validateWorkStatus() {
      if (
        (this.isFieldRequired('work_status') && this.work_status == '') ||
        this.work_status == null
      ) {
        this.requiredWorkStatus = true;
        return false;
      }
      this.requiredWorkStatus = false;
      if (this.work_status == WORK_STATUS_YES) {
        if (this.company_name === '' || this.company_name === null) {
          this.requiredCompanyName = true;
        }
        if (this.industry_type === '' || this.industry_type === null) {
          this.requiredIndustryType = true;
        }
        if (
          this.work_contract_type === '' ||
          this.work_contract_type === null
        ) {
          this.requiredWorkContractType = true;
        }
        if (this.occupation_type === '' || this.occupation_type === null) {
          this.requiredOccupationType = true;
        }

        return (
          this.company_name !== '' &&
          this.company_name !== null &&
          this.industry_type !== '' &&
          this.industry_type !== null &&
          this.work_contract_type !== '' &&
          this.work_contract_type !== null &&
          this.occupation_type !== '' &&
          this.occupation_type !== null
        );
      } else {
        return true;
      }
    },

    validateSchoolName() {
      this.requiredSchoolName =
        this.school_name == '' && this.university_input_text_flag == 1;
    },

    validateFacultyName() {
      this.requiredFacultyName =
        this.faculty == '' && this.faculty_input_text_flag == 1;
    },

    goBack() {
      this.$router.replace({
        name: 'register-applicant',
        query: { event_day_register_url_code: this.urlRegisterCode, step: 1 }
      });
    },

    nextStepThree() {
      this.validateForm();

      const {
        study_status,
        last_academic_history,
        university_id,
        university_input_text_flag,
        school_name,
        faculty_id,
        faculty_input_text_flag,
        faculty,
        graduation_month,
        work_status_text,
        work_status,
        company_name,
        industry_type,
        occupation_type,
        work_contract_type,
        resignation_month,
        jlpt_level,
        english_level,
        toeic_score,
        expect_occupation_type,
        expect_occupation_type_text,
        expected_requirements,
        expected_pay,
        any_additional_comments,
        work_location,
        self_promotion, // feature #248
        skillArray,
        skill_name_text,
        skill_type
      } = this;

      const arrOccupationType = [];
      arrOccupationType.push(occupation_type);

      const data = {
        study_status,
        last_academic_history,
        university_id,
        university_input_text_flag,
        school_name: this.convertStr(school_name),
        faculty_id,
        faculty_input_text_flag,
        faculty: this.convertStr(faculty),
        graduation_month,
        work_status,
        work_status_text,
        company_name:
          work_status === WORK_STATUS_YES
            ? this.convertStr(company_name)
            : null,
        industry_type: work_status === WORK_STATUS_YES ? industry_type : null,
        occupation_type: arrOccupationType,
        work_contract_type:
          work_status === WORK_STATUS_YES ? work_contract_type : null,
        resignation_month: resignation_month,

        jlpt_level,
        english_level,
        toeic_score,
        skill_name_text,
        skill_type,
        expect_occupation_type,
        expect_occupation_type_text,
        expected_requirements,
        expected_pay,
        any_additional_comments,
        work_location,
        self_promotion, // feature #248
        skillArray
      };

      this.$store.dispatch('storageStepTwo', { data });

      if (
        !this.$v.$error &&
        this.validateWorkStatus() &&
        this.checkUniversity() &&
        this.checkFaculty()
      ) {
        this.$router.replace({
          name: 'register-applicant',
          query: { event_day_register_url_code: this.urlRegisterCode, step: 3 }
        });
      }
    },

    checkUniversity() {
      return !(this.university_id == '0' && this.school_name == '');
    },

    checkFaculty() {
      return !(this.faculty_id == '0' && this.faculty == '');
    },

    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split('/');
      return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
    },

    checkSizeObject(obj = {}) {
      let size = 0;

      Object.keys(obj).map(() => {
        size++;
      });
      return size;
    },

    handleAddSkill() {
      if (this.countSkill < 10) {
        const skillArray = this.skillArray;
        const nameObj = 'skill' + this.checkSizeObject(skillArray);
        const skillAdd = {
          key: this.checkSizeObject(skillArray),
          skillType: '',
          skill: ''
        };

        skillArray[nameObj] = skillAdd;

        return (this.skillArray = Object.assign({}, skillArray));
      }
    },

    handleDeleteSkill() {
      const skillArray = this.skillArray;
      const objDelete = 'skill' + (this.checkSizeObject(skillArray) - 1);

      delete skillArray[objDelete];

      return (this.skillArray = Object.assign({}, skillArray));
    },

    dataFiltered(skill_type_code) {
      let arr = [];

      arr = this.m_skill.filter(
        (ele) => ele.skill_type_code == skill_type_code
      );

      return arr;
    },

    getSkillArray() {
      const skillArray = this.skillArray;

      const arrSkillID = [];
      Object.keys(skillArray).map((key) => {
        const id = skillArray[key].skill;
        if (id !== '') {
          arrSkillID.push(id);
        }
      });

      return arrSkillID;
    },

    onchangeFaculty(event) {
      this.faculty = '';
      const currentFaculty = this.m_faculty.find(
        (ele) => ele.id === Number(event.target.value)
      );
      this.faculty_input_text_flag = currentFaculty
        ? currentFaculty.input_text_flag
        : '';
    },

    onchangeUniversity(event) {
      this.school_name = '';
      const currentUniversity = this.m_university.find(
        (ele) => ele.id === Number(event.target.value)
      );
      this.university_input_text_flag = currentUniversity
        ? currentUniversity.input_text_flag
        : '';
    }
  },

  created() {
    const registerData =
      localStorage.getItem('registerData') !== null
        ? JSON.parse(localStorage.getItem('registerData'))
        : null;

    if (registerData !== null && registerData.stepTwo) {
      const stepTwo = registerData.stepTwo;
      Object.keys(stepTwo).forEach((key) => {
        if (this.hasOwnProperty(key)) {
          this[key] = stepTwo[key];
        }
      });
    } else {
      // Load default values from m_event.modify_fields
      if (this.m_event && this.m_event.modify_fields) {
        this.m_event.modify_fields.forEach((field) => {
          if (field.default_value && this.hasOwnProperty(field.name)) {
            this[field.name] = field.default_value;
          }
        });
      }
    }
  },

  computed: {
    ...mapGetters({
      m_template: 'getMTemplate',
      m_event: 'getMEvent'
    }),
    resignationMonthFormatted() {
      return this.formatDate(this.resignation_month);
    },
    checkWorkStatus() {
      return this.work_status == WORK_STATUS_YES;
    },
    getHintMonth() {
      if (this.$i18n.locale === LANG_CODE_JAPANESE) {
        return HINT_TEXT_MONTH_JAPANESE;
      } else {
        return HINT_TEXT_MONTH_VIETNAMESE;
      }
    },
    getInputExample() {
      return this.m_input_example.filter((el) => el.screen_id === 2);
    }
  }
};
</script>

<style>
.input-example-style {
  margin-top: 1rem;
  white-space: pre-wrap;
}
</style>
